import { Component, Input } from "@angular/core";

/**
 * Presentational fragment for the shared appointment-summary block (center
 * graphic, imaging-center name, exam line, patient name and confirmation number)
 * that appears identically inside several patient-notification email cards.
 *
 * Rendered inline at the position the original elements occupied. Only the top
 * padding of the imaging-center heading varies between cards, so the heading's
 * padding shorthand is exposed as an input.
 */
@Component({
  selector: "app-appointment-info",
  templateUrl: "./appointment-info.component.html",
})
export class AppointmentInfoComponent {
  // Padding shorthand applied to the "Imaging Center Name" heading.
  @Input() imagingCenterPadding = "10px 164px 0 164px";
}
